import './App.css';
import ShowEvent from './page/product/ShowEvents'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';
import AddEvents from "./page/product/AddEvents";
import React, { useEffect } from "react";
import {Calendar_event} from "./page/product/calendar"
import Default from "./components/Default"
import {message} from "antd";
import {useSelector} from "react-redux";
import 'moment/locale/fr';
import {ConfigProvider} from "antd";
import en_US from "antd/lib/locale/en_US";
import frFR from "antd/lib/locale/fr_FR";
import IndexEvent from './components/IndexEvent';
import {getSafeColor} from './utils/color';

message.config({
    maxCount: 1,
});

function App() {
    const lang = useSelector((state) => state.reducer.lang)
     const { dashboard_module } = useSelector(
        (state) => state.ReducerUserData.modules
      );

      useEffect(() => {
            const queryParams = new URLSearchParams(window.location.search);
            const safeColor = getSafeColor(queryParams.get('color'));

            if (safeColor) {
                  document.documentElement.style.setProperty('--primary-color', safeColor);
                  document.documentElement.style.setProperty('--secondary-color', safeColor);
                  document.body.classList.add('custom-theme');
            } else {
                  document.documentElement.style.removeProperty('--primary-color');
                  document.documentElement.style.removeProperty('--secondary-color');
                  document.body.classList.remove('custom-theme');
            }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
      
      useEffect(() => {
            const applyTheme = (theme) => {
                  const body = document.body;
                  const html = document.documentElement;

                  body.classList.remove('dark-theme', 'light-theme');
                  html.classList.remove('dark-theme', 'light-theme');

                  if (theme === 'dark') {
                        body.classList.add('dark-theme');
                        html.classList.add('dark-theme');

                        body.style.backgroundColor = '#1e1e1e';
                        body.style.color = '#e0e0e0';
                        html.style.backgroundColor = '#1e1e1e';
                  } else {
                        body.classList.add('light-theme');
                        html.classList.add('light-theme');

                        body.style.backgroundColor = '#ffffff';
                        body.style.color = '#212121';
                        html.style.backgroundColor = '#ffffff';
                  }
            };

            const handleThemeMessage = (event) => {
                  if (event.data && event.data.info === 'updateTheme') {
                        const theme = event.data.theme;
                        applyTheme(theme);
                        localStorage.setItem('theme', theme);
                  }

                  if (event.data && event.data.info === 'clearTheme') {
                        localStorage.removeItem('theme');
                        // applyTheme('light');
                  }
            };

            window.addEventListener('message', handleThemeMessage);

            const savedTheme = localStorage.getItem('theme') || 'light';
            applyTheme(savedTheme);

            return () => {
                  window.removeEventListener('message', handleThemeMessage);
            };
  // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
      
      useEffect(()=>{
            console.log(dashboard_module?.custom_theme_right_action?.authorized,"event_module");
            if(dashboard_module?.custom_theme_right_action?.authorized) document.body.classList.add('client-demo')
            else  document.body.classList.remove('client-demo');
      },[dashboard_module])
    return (
        <ConfigProvider locale={lang === "en" ? en_US : frFR}>
            <div className="App">
                <BrowserRouter>
                    <Switch>
                        <Redirect exact from="/" to="/events/list"/>
                        <Route exact path='/events/list' component={ShowEvent}/>
                        <Route exact path='/events/indexation/:conferenceKey' component={IndexEvent}/>
                        <Route exact path='/events/addevent' component={AddEvents}/>
                        <Route exact path='/events/editevent/:id' component={AddEvents}/>
                        <Route path='/events/calendar-event' component={Calendar_event}/>
                        <Route component={Default}/>
                    </Switch>
                </BrowserRouter>
            </div>
        </ConfigProvider>
    );
}

export default App;
